module.exports = __webpack_public_path__ + "static/img/personal_btn1.54ec7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/personal_btn1.png
// module id = NFbT
// module chunks = 4